<template>
    <div>
        <ul v-if="is_staff()" class="pagination">
            <li :class='"page-item pagination-prev-nav" + (pagination.prev_page_url == null ? " disabled" : "")'>
                <a class="page-link" href="javascript:void(0)" aria-label="Previous" v-on:click.prevent="changePage(pagination.current_page - 1)">
                    <span aria-hidden="true">«</span>
                    </a>
            </li>
            <template v-if='!simple' >
                <li class="page-item" v-for="page in pagesNumber" :key='page' :class="{'active': page == pagination.current_page}">
                    <a class="page-link" href="javascript:void(0)" v-on:click.prevent="changePage(page)">{{ page }}</a>
                </li>
            </template>
            <li :class='"page-item pagination-next-nav" + (pagination.next_page_url == null ? " disabled" : "")'>
                <a class="page-link" href="javascript:void(0)" aria-label="Next" v-on:click.prevent="changePage(pagination.current_page + 1)">
                    <span aria-hidden="true">»</span>
                    </a>
            </li>
        </ul>

        <ul v-else class="pagination d-flex justify-content-center p-1">
            <li :class='"pagination-prev-nav"'>
                <a :class='"btn btn-sm btn-round btn-primary" + (pagination.prev_page_url == null ? " disabled" : "")' href="javascript:void(0)" aria-label="Previous" v-on:click.prevent="changePage(pagination.current_page - 1)">
                    {{ $t('translations.previous') }}
                    </a>
            </li>
            <template v-if='!simple' >
                <li class="" v-for="page in pagesNumber" :key='page' :class="{'active': page == pagination.current_page}">
                    <a class="btn btn-sm btn-round btn-primary" href="javascript:void(0)" v-on:click.prevent="changePage(page)">{{ page }}</a>
                </li>
            </template>
            <li :class='"pagination-next-nav"'>
                <a :class='"btn btn-sm btn-round btn-primary ml-1" + (pagination.next_page_url == null ? " disabled" : "")' href="javascript:void(0)" aria-label="Next" v-on:click.prevent="changePage(pagination.current_page + 1)">
                    {{ $t('translations.next') }}
                    </a>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props: {
        pagination: {
            type: Object,
            required: true
        },
        offset: {
            type: Number,
            default: 2
        },
        simple: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        pagesNumber() {
            if (!this.pagination.to) {
                return [];
            }
            let from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            let to = from + (this.offset * 2);
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
                from = to - (this.offset * 2);
                if (from < 1) {
                    from = 1;
                }

            }
            let pagesArray = [];
            for (let page = from; page <= to; page++) {
                pagesArray.push(page);
            }
            return pagesArray;
        }
    },
    methods: {
        changePage(page) {
            this.pagination.current_page = page;
            this.$emit('paginate');
        }
    }
}
</script>
